/** API do ambiente, derivada do host (o mesmo build roda em staging e produção). */
export function apiBaseUrl(hostname = typeof location !== 'undefined' ? location.hostname : 'localhost'): string {
  if (hostname === 'backoffice.licita.dev') return 'https://api.licita.dev';
  if (hostname === 'staging-backoffice.licita.dev') return 'https://staging-api.licita.dev';
  return import.meta.env.VITE_API_URL ?? 'http://localhost:3000';
}

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
  ) {
    super(message);
  }
}

export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, ...rest } = init;
  const res = await fetch(`${apiBaseUrl()}${path}`, {
    credentials: 'include',
    ...rest,
    headers: { ...(json !== undefined ? { 'content-type': 'application/json' } : {}), ...rest.headers },
    body: json !== undefined ? JSON.stringify(json) : rest.body,
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string; message?: string };
    throw new ApiError(res.status, body.error ?? 'ERRO', body.message ?? 'Não foi possível concluir.');
  }
  return (res.status === 204 ? undefined : await res.json()) as T;
}
